export type IdogcamAccessType = 'public' | 'private';

export interface IdogcamIntegration {
    configured: boolean;
    kennelId: string | null;
    erpcode: string | null;
    platformConfigured: boolean;
    camerasCount: number;
}

// Account identifiers iDogCam gives each business; stored per location (marketplace).
export interface IdogcamCredentials {
    kennelId: string;
    erpcode: string;
}

export interface IdogcamCamera {
    id: number;
    uuid: string;
    externalId: string;
    name: string;
    active: boolean;
    accessType: IdogcamAccessType | null;
    addressId: number | null;
    addressName: string | null;
    roomId: number | null;
    roomName: string | null;
    roomUnitId: number | null;
    roomUnitName: string | null;
}

// iDogCam "Location" inside a marketplace is an address; appointments are matched by address_id.
export interface IdogcamLocation {
    id: number;
    name: string;
    main: boolean;
}

export interface IdogcamRoomUnit {
    id: number;
    name: string;
    active: boolean;
}

export interface IdogcamRoom {
    id: number;
    name: string;
    units: Array<IdogcamRoomUnit>;
}

export interface IdogcamCamerasPage {
    configured: boolean;
    locations: Array<IdogcamLocation>;
    cameras: Array<IdogcamCamera>;
    page: number;
    size: number;
    totalPages: number;
    totalRecords: number;
}

export interface IdogcamCameraChanges {
    active: boolean;
    accessType: IdogcamAccessType | null;
    addressId: number | null;
    roomId: number | null;
    roomUnitId: number | null;
}

export interface IdogcamViewerLaunch {
    viewerUrl: string;
    method: string;
    authParam: string;
    auth: string;
}

export const IDOGCAM_ICON_SRC = '/images/settings/integrations/idogcam.png';
